module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-8"
    }
  }, [_c('h2', {
    staticClass: "head"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IST OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BBREVIATIONS")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SED IN")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("B&L")]), _vm._v("Battles and Leaders of the Civil War")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("New Orleans Ship ")]), _vm._v("Ship Register and Enrollments of New Orleans, Louisiana. 6")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Register")]), _vm._v("Vols. Baton Rouge, Louisiana: LSU Press, 1941-1942.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Confederate Officers")]), _vm._v("Officers of the Confederate States Navy, 1861-1865, (Washington D.C., Government Printing Office, 1898).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("DANFS")]), _vm._v(" Dictionary of American Naval Fighting Ships.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("OR")]), _vm._v(" The War or the Rebellion: A Compilation of the Official Records of the Union and Confederate Armies.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("ORN")]), _vm._v(" Official Records of the Union and Confederate Navies in the War of the Rebellion.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Subject File")]), _vm._v("Subject File of the Confederate States Navy (Records Group 45), National Archives Building, Washington, DC.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Vessel Papers")]), _vm._v(" Confederate Vessel Papers: Papers Pertaining to Vessels Involved with the Confederate States of America (War Department Collection of Confederate Records, Records Group 109), National Archives Building, Washington, DC.")])]), _c('p', {
    staticClass: "head"
  }, [_c('a', {
    attrs: {
      "id": "VPS-8"
    }
  }), _c('a', {
    attrs: {
      "id": "a1"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOSSARY OF")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMS")])])]), _c('a', {
    attrs: {
      "id": "a1"
    }
  }, [_c('p', {
    staticClass: "cen"
  }, [_vm._v("Vessel Types & Weapons")]), _vm._v(" "), _c('p', {
    staticClass: "indent_1"
  }, [_vm._v("Please note that some of the naval vessels mentioned in this study used a mix of different forms of protection, depending on what materials were available.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Casemate Ironclad ")]), _vm._v(" Ironclad vessel using a fully enclosed protective shield, complete with roof and often running most of the length of a ship, as the main deck for cannon.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Cottonclad")]), _vm._v(" Vessel using bales of cotton as protection against enemy fire, often to shield paddle wheels and exposed walking-beam engines on river steamers.")])]), _c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }, [_c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Floating Battery")]), _vm._v(" Immobile craft, typically anchored in place, and used as a platform for firing heavy artillery. Variants included types with partial casemates, batteries built on barges, and batteries converted from semi-submersible dry-docks.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Ironclad")]), _vm._v(" Vessel using iron plates against enemy fire, typically several inches thick. Often railroad iron rails were bolted on to form protection when iron plates were unavailable or could not be manufactured.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Monitor")]), _vm._v(" Name given to the Union’s ironclads with round, iron-plated revolving turrets housing heavy guns. Several Monitor classes were employed by the Union Navy, including double and triple turret variants and smaller Mississippi River versions.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Mortar Boat")]), _vm._v(" Vessel whose primary weapon was a large mortar, capable of firing shells in a high arc over fortifications and at targets beyond a line of sight.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Privateer")]), _vm._v(" Vessel privately owned and, possessing a letter of marque and reprisal, authorized to attack the merchant and naval vessels of a designated enemy. Captured enemy ships could be condemned and sold in a prize court, with the privateer’s crew and investors receiving the profits.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Ram")]), _vm._v(" Vessel with a metal ram placed on its bow used to smash into enemy ships, creating a large hole to force it to sink.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Revenue Cutter ")]), _vm._v(" Small vessels operated by either the United States Revenue Marine or Confederate States Revenue Service. Their purpose was to collect taxes on imports and exports in port cities. Revenue cutters augmented naval forces of both sides.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Semi-Submersible")]), _vm._v(" Vessel that could partially submerge for a time to limit its exposure to enemy fire.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Steamer")]), _vm._v("Vessel that used steam engines as a means of propulsion. The engine turned a screw propeller under the hull or paddle wheels typically located on the vessel’s stern or along either side.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Submarine")]), _vm._v(" Vessel that could completely submerge for extended periods of time.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Timberclad ")]), _vm._v(" Vessel that used wooden logs or thick wooden structures as protection against enemy small arms fire.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Tinclad")]), _vm._v("Vessel that used thin sheet metal as protection against enemy small arms fire.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Torpedo Boat  ")]), _vm._v(" Small steam craft with an explosive device (“torpedo”) at the end of a long spar placed over its bow.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_1"
  }, [_c('span', {
    staticClass: "b_hang"
  }, [_vm._v("Torpedo")]), _vm._v(" An underwater explosive detonated by contact or from shore by wire connection. Known as a “mine” today.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa84b38c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/007_List_of_Abbrivation.vue
// module id = 78
// module chunks = 0